import { generateIdentifiers } from './companyHelpers';

import InsiderTransactionsSvc from '../services/dbServices/InsiderTransactionsSvc';

export const tryInsiderTransactions = async (tickers, params = {}) => {
  const identifier = generateIdentifiers(tickers.map((ticker) => ({
    ticker: ticker.full_name,
  })));
  const transactions = await InsiderTransactionsSvc.getCompanyInsiderTransactions({
    identifier,
    ...params,
  });

  return {
    identifier,
    transactions,
  };
};

export default tryInsiderTransactions;
